import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { encodedSignUpDataSchema } from '@nesso/identity-contracts/sign-up.models';

import { SignupPage } from '@/pages/signup';

const signupSearchSchema = z.object({
    signUpData: encodedSignUpDataSchema.optional().catch(undefined),
});

export const Route = createFileRoute('/signup')({
    component: SignupPage,
    validateSearch: signupSearchSchema,
});
